import React, { useEffect } from "react";

import { useDebounce } from "use-debounce";
import shallow from "zustand/shallow";

import { deleteUrlParam, setUrlParam } from "../../../../utils/urlParams";
import NewInput from "../../../shared/forms/NewInput";
import useStore from "../store";

const Search = () => {
    const [setSelectedProductGroupId, setSearch, search, setPage, getData] =
        useStore(
            (state) => [
                state.setSelectedProductGroupId,
                state.setSearch,
                state.search,
                state.setPage,
                state.getData,
            ],
            shallow
        );

    const [debouncedSearch] = useDebounce(search, 500);

    useEffect(() => {
        if (debouncedSearch) {
            onSearch();
        }
    }, [debouncedSearch]);

    const onLocalChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(event.target.value);
        setUrlParam("search", event.target.value);
    };

    const onSearch = () => {
        //set page always to 1 before doing a new search. (setPage also does the fetch)
        void setSelectedProductGroupId(null);
        void setPage(1);
        deleteUrlParam("group");
        deleteUrlParam("page");
        void getData();
    };

    return (
        <NewInput
            placeholder="Suche"
            value={search}
            onChange={onLocalChange}
            fullWidth
            handleClick={onSearch}
        />
    );
};

export default Search;
